export default import.meta.ROLLDOWN_FILE_URL_Ar3aYpyYj2aPFA5cGwTEqg